import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, statusConvertor, translate } from '../../utils/useful'
import FixedView from '../FixedView'

class StatusSelectInput extends React.Component {
    state = {
        // status:{
        //     'C':{key:'C',label:'{{lang}}Connected',color:'#fff',backgroundColor:'007aff'},
        //     'P':{key:'P',label:'{{lang}}Pending',color:'#fff',backgroundColor:'#9ab'},
        //     'S':{key:'S',label:'{{lang}}Self',color:'#fff',backgroundColor:'#000'},
        // }
    }


    componentDidMount() {
        setTimeout(() => {
            this.setState({ showFixedView: true })
        }, 100);
    }



    getInfo(data) {
        let items = this.props.header?.information?.items
        let info
        if (Array.isArray(items)) {
            items.forEach(item => {
                if (data == item.key) {
                    info = item
                }
            });
        }

        return info

    }

    openList = () => {
        this.fixedView.showView()
    }


    changeValue = (item) => {
        let value = item.key
        this.props.changeValue(this.props.header.key, value, this.props.extra)
        this.fixedView.hideView()
    }



    render() {
        let info = this.getInfo(this.props.data)
        return (
            <div className="w-100 h-100 flexc status-select-input position-relative" ref={el => this.nodeRef = el}>
                <div className='w-100 flexc' style={{ minHeight: 30 }} onClick={() => this.openList()}>
                    <p className="text-capitalize text-smaller br-20 select-option cursor-pointer" style={{ color: info?.color, backgroundColor: info?.bgColor }}>{checkTranslation(info?.label)}</p>
                </div>
                {this.state.showFixedView && (
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.nodeRef} maxHeight={200} zIndex={4} topOffset={0} width={200} >

                        <div className=' br-10 bg-white box-shadow-20 py-3 d-flex flex-column' style={{ top: 0, minWidth: 150, maxWidth: 200, maxHeight: 200 }}>

                            <div className='px-3 '>
                                {this.props.header?.information?.items?.map((item, index) => {
                                    return (
                                        <button className='mb-2 flexc' key={item.key} onClick={() => this.changeValue(item)}>
                                            <p className="text-capitalize text-smaller text-center br-20 cursor-pointer select-option" style={{ color: item?.color, backgroundColor: item?.bgColor }}>{checkTranslation(item?.label)}</p>
                                        </button>
                                    )
                                })}
                            </div>
                            <div className='flexcb pt-2 px-3' style={{ borderTop: '1px solid #f0f0f0' }}>
                                <div className='flexc cursor-pointer' style={{ color: '#999' }}>
                                    <p>{translate('Edit Labels')}</p>
                                </div>

                                <div className=' flexc cursor-pointer' onClick={() => this.changeValue()}>
                                    <p className="text-capitalize text-smaller text-center px-1" style={{ color: '#007aff' }}>Clear</p>
                                </div>
                            </div>

                        </div>
                    </FixedView>
                )}
            </div>
        )
    }
}

export default StatusSelectInput;